import Cookies from 'universal-cookie';

const cookies = new Cookies();

function decodeBase64Url(value) {
  try {
    const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    return window.atob(padded);
  } catch (error) {
    return null;
  }
}

export function getSessionToken() {
  return cookies.get('TOKEN');
}

export function getSessionPayload() {
  const token = getSessionToken();

  if (!token) {
    return null;
  }

  const [, payload] = token.split('.');
  if (!payload) {
    return null;
  }

  const decoded = decodeBase64Url(payload);
  if (!decoded) {
    return null;
  }

  try {
    return JSON.parse(decoded);
  } catch (error) {
    return null;
  }
}

export function isAdminSession() {
  return getSessionPayload()?.is_admin === true;
}

export function persistSession({ token, userId }) {
  cookies.set('TOKEN', token, { path: '/', secure: window.location.protocol === 'https:', sameSite: 'strict' });

  if (userId !== undefined && userId !== null) {
    localStorage.setItem('id', String(userId));
  }
}

export function clearSession() {
  localStorage.removeItem('id');
  localStorage.removeItem('admin');
  cookies.remove('TOKEN', { path: '/' });
}
